module.exports = __webpack_public_path__ + "img/slc.8160d2ef.jpg";